import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 根据关键字生成唯一key值
 * @param {string} key [一个关键词]
 * @return {String} [唯一的值]
 */
const uniqueKeyMap = {};
export function uniqueKey(key) {
  const uuid = uniqueKeyMap[key] ? uniqueKeyMap[key] + 1 : 1000;
  uniqueKeyMap[key] = uuid;
  return key + uuid;
}
export function mergeDefault() {
  let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const obj = _objectSpread({}, source);
  Object.keys(target).forEach(key => {
    if (target[key] !== null) {
      obj[key] = target[key];
    }
  });
  return obj;
}
export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
export function firstUpperCase(str) {
  return str.replace(/^\S/, s => s.toUpperCase());
}

// 数组乱序
export function shuffle(arr) {
  for (let i = arr.length; i; i--) {
    const j = Math.floor(Math.random() * i);
    [arr[i - 1], arr[j]] = [arr[j], arr[i - 1]];
  }
  return arr;
}
// 找到指定名称的父级
export function findComponents(context, componentName) {
  const parents = [];
  const parent = context.$parent;
  if (parent) {
    if (parent.$options.name === componentName) parents.push(parent);
    return parents.concat(findComponents(parent, componentName));
  } else {
    return [];
  }
}
export const getRanges = function getRanges(min, max) {
  let fillZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const res = [];
  for (let i = min; i <= max; i++) {
    const str = i < 10 && fillZero ? "0".concat(i) : String(i);
    res.push(str);
  }
  return res;
};
export * from './date';
export * from './theme';

// 中划线转驼峰
export const replaceCamelCase = str => str.replace(/-([a-z])/g, (match, group) => group.toUpperCase());